import {
  CollectionPageContents_collection_contents_edges_node_VideoContent,
  Visibility,
} from '../../../../../../../globalTypes'

interface ContentNode {
  node: Partial<CollectionPageContents_collection_contents_edges_node_VideoContent>
}

interface ContentConnection {
  edges?: ContentNode[]
}

interface Module {
  contents: ContentConnection
}

interface ModuleEdge {
  node: Module
}

interface ModuleConnection {
  edges?: ModuleEdge[]
}

interface CollectionData {
  contents?: ContentConnection
  modules?: ModuleConnection
}

const getVideoPreviewFromContents = (contents: ContentConnection) => {
  if (!contents || contents.edges.length === 0) return null

  const { node: firstContent } = contents.edges[0]

  if (
    firstContent.__typename === 'VideoContent' &&
    firstContent.visibilityForCollection === Visibility.public &&
    firstContent.cover
  ) {
    return firstContent
  }
}

/**
 * This function gets, if present, the first video content stored in the collection to use as a preview cover.
 * @param collection Collection data, composed of contents and modules that stores video content information.
 * @returns The video usable as cover content stored in the collection.
 */
export const getVideoPreview = (
  collection: CollectionData = {} as CollectionData
) => {
  let videoPreview = getVideoPreviewFromContents(collection.contents)

  if (!videoPreview && collection?.modules?.edges.length > 0) {
    const { node: firstModule } = collection.modules.edges[0]
    videoPreview = getVideoPreviewFromContents(firstModule.contents)
  }

  return videoPreview
}
